export const RELATIVE_ERROR_MESSAGES = {
  pastDate: 'The relative date cannot be in the past',
  futureDate: 'The relative date is too far into the future',
  invalidDate: 'Invalid date',
};
